import {
	Card,
	CardContent,
	CardHeader,
	CardMedia,
	MenuItem,
	Menu,
	Grid,
	IconButton,
	makeStyles,
	Typography,
	TextField,
	Button,
} from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import React from 'react';
import Image from '../../Moderation/partials/Image';
import moment from 'moment';
import { openWidgetChallengePosts } from '../../../lib/widget-loader';

export const Challenge = ({ challenge, editChallenge, deleteChallenge, participations }) => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleAction = action => {
		handleClose();

		if (action === 'edit') {
			editChallenge();
		} else if (action === 'delete') {
			deleteChallenge();
		}
	};

	const openChallengePosts = () => {
		openWidgetChallengePosts(challenge._id, challenge.hashtag);
		handleClose();
	}

	return (
		< Card className={classes.root} >
			<CardHeader
				title={<Typography variant='h6'>{challenge.title}</Typography>}
				subheader={
					<React.Fragment>
						{moment.utc(challenge.from).format('MM/DD/YYYY')} - {moment.utc(challenge.to).format('MM/DD/YYYY')}
						<div>
							Participations: {participations || 0}
						</div>
						<div onClick={openChallengePosts} style={{
							fontSize: '16px',
							textDecoration: 'underline',
							color: '#0095ff',
							cursor: 'pointer',
							width: 'fit-content'
						}}>
							Show Participations
						</div>
					</React.Fragment>
				}
				action={
					<React.Fragment>
						<IconButton onClick={handleClick}>
							<MoreHorizIcon />
						</IconButton>
						<Menu
							anchorEl={anchorEl}
							keepMounted
							open={open}
							onClose={handleClose}
							classes={{
								paper: classes.menuRoot,
							}}
						>
							<MenuItem onClick={() => handleAction('edit')}>Edit</MenuItem>
							<MenuItem onClick={() => handleAction('delete')}>Delete</MenuItem>
						</Menu>
					</React.Fragment>
				}
			/>
			<div className={classes.previewContainer}>
				<div className={classes.challengeMargin}>
					<div>
						<p>
							{challenge.title}
						</p>
						<p>
							{challenge.body}
						</p>
						<Button
							className={classes.button}
							disableElevation
							variant="contained"
						>
							{challenge.button}
						</Button>
						<p className={classes.legalTerms}>
							Legal terms
						</p>
					</div>
					<CardMedia className={classes.media} image={challenge.image} />
				</div>
				<div className={classes.center}>
					<p>
						{challenge.postMessageTitle}
					</p>
					<p>
						{challenge.postMessageDescription}
					</p>
					{challenge.couponCode ? (
						<TextField
							variant="outlined"
							readOnly
							size={'small'}
							className={classes.couponText}
							value={challenge.couponCode} />
					) : null}
					<CardMedia className={classes.mediaCoupon} image={challenge.postMessageImage} />
				</div>
			</div >
			< CardContent >
				<Typography paragraph variant='body1' color='textPrimary' component='p'>
					Selected items:
				</Typography>
				< Grid container style={{ marginTop: 12 }}>
					{
						challenge.items.map(item => (
							<Grid item key={item._id} className={classes.item}>
								<Image src={item.img} width='100px' height='120px' />
							</Grid>
						))
					}
				</Grid >
			</CardContent >
		</Card >
	);
};

const useStyles = makeStyles(() => ({
	root: {

		borderRadius: 10,
		width: 711,
	},
	challengeMargin: {
		width: '100%',
		display: 'flex',
		backgroundColor: 'white',
		margin: '5px 0',
		padding: '20px',
		fontSize: '14px',
		borderRight: 'solid 1px lightgrey',
	},
	previewContainer: {
		fontWeight: '500',
		display: 'flex',
		flexDirection: 'row',
		backgroundColor: '#F2F2F2'
	},
	legalTerms: {
		color: 'darkgrey',
		fontSize: '12px'
	},
	media: {
		width: '35%',
		height: '75%',
	},
	mediaCoupon: {
		width: '80%',
		height: 0,
		paddingTop: '56.25%', // 16:9
	},
	item: {
		marginBottom: 2,
		marginRight: 2,
	},
	menuRoot: {
		minWidth: 200,
	},
	couponText: {
		textAlignLast: 'center',
	},
	center: {
		textAlign: '-webkit-center',
		margin: '5px 0',
		padding: '5px',
		backgroundColor: 'white',
		width: '50%',
	},
	button: {
		backgroundColor: 'black',
		color: 'white'
	},
}));
